export default "__VITE_ASSET__DO7jHFHK__"